import angular from 'angular';

const wavesAttach = angular.module('ttb.directives.wavesAttach', [])
    .directive('wavesAttach', () => {
        return (scope, element, attrs) => {
            Waves.attach(element[0]);
        };
    })
    .name;

export default wavesAttach;



// WEBPACK FOOTER //
// ../directives/waves-attach.js